import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatatableComponent } from '../datatable/datatable.component';

@Component({
  selector: 'datatable-pagination',
  templateUrl: './datatable-pagination.component.html',
  styleUrl: './datatable-pagination.component.scss',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatatablePaginationComponent<T = unknown> {
  readonly table = input.required<DatatableComponent<T>>();
  readonly pageSizeOptions = input<number[]>([10, 20, 30, 50, 100]);

  readonly pageSizeChange = output<number>();

  protected getSelectedCount(): number {
    return this.table().getSelectedCount();
  }

  protected getTotalRows(): number {
    return this.table().table.getRowCount();
  }

  protected getPageCount(): number {
    return this.table().getPageCount();
  }

  protected getPageIndex(): number {
    return this.table().getPageIndex();
  }

  protected getPageSize(): number {
    return this.table().getPageSize();
  }

  protected canPreviousPage(): boolean {
    return this.table().canPreviousPage();
  }

  protected canNextPage(): boolean {
    return this.table().canNextPage();
  }

  protected onPreviousPage(): void {
    this.table().onPreviousPage();
  }

  protected onNextPage(): void {
    this.table().onNextPage();
  }

  protected onPageSizeChange(size: number): void {
    this.table().setPageSize(size);
    this.pageSizeChange.emit(size);
  }
}
